export default defineNuxtPlugin(() => {
    const id = useRuntimeConfig().public.callRailAccount
    if (!process.client || !id) return
    const s = document.createElement('script')
    s.async = true
    s.src = `https://cdn.callrail.com/companies/${id}/7a2c9c2b8f4567890abc/12/swap.js`
    document.head.appendChild(s)
  })
  